<template>
  <div :class="['dropdown', classList]">
    <div
      ref="input"
      class="dropdown__field"
      tabindex="-1"
      @focus="onFocus"
      @keydown.down.stop.prevent="navigateOptions('down')"
      @keydown.up.stop.prevent="navigateOptions('up')"
      @keydown.enter.prevent="onEnterPress"
      @keydown.esc="isOpened = false"
      @keydown.tab="onBlur"
      @click.stop="toggleMenu"
    >
      <div class="dropdown__input">Локации</div>

      <div class="dropdown__arrow" :class="{ _reversed: reverse }">
        <IconSelectArrow class="purchase-detail__arrow" color="#F18E35" />
      </div>
    </div>

    <transition name="menu">
      <div
        v-click-outside="onClickOutside"
        v-if="isOpened"
        ref="menu"
        class="dropdown__menu"
        :class="{ _reverse: reverse }"
      >
        <perfect-scrollbar class="dropdown__scrollbox">
          <draggable v-model="floors" item-key="id" handle=".drag-handle">
            <template #item="{ element, index }">
              <div
                class="dropdown__option"
                @click="onOptionSelect(element.order)"
              >
                <DragIcon class="drag-handle" :style="{ color: '#ADADAD' }" />
                <span class="order"> {{ index + 1 }} </span>
                <IconPen
                  v-if="element.id !== editId"
                  @click.stop="editId = element.id"
                />

                <template v-else>
                  <SuccessSmallIcon @click.stop="saveInputValue" />
                  <VInput
                    class="input_text"
                    v-model:value="editName"
                    max-length="32"
                  />
                </template>

                <span v-if="element.id !== editId" class="title">
                  {{ element.name }}
                </span>
                <AcceptModalButton
                  v-if="element.id !== editId"
                  acceptButtonText="Удалить"
                  cancelButtonText="Отменить"
                  title="Удалить этаж?"
                  text="Вы уверены, что хотите удалить этаж. Восстановить данные будет невозможно."
                  @accept="deleteFloor(element.id)"
                  v-slot="scope"
                >
                  <IconDeleteCan
                    @click.stop="scope.open"
                    :style="{ marginLeft: 'auto' }"
                  />
                </AcceptModalButton>
                <IconCross v-else color="#F18E35" @click.stop="closeInput" />
              </div>
            </template>
          </draggable>
        </perfect-scrollbar>
        <div class="button" @click="addFloor">
          <IconPlus /> <span>Добавить</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import IconSelectArrow from "@/components/icons/IconSelectArrow";
import IconPlus from "@/components/icons/IconPlus.vue";
import IconDeleteCan from "@/components/icons/IconDeleteCan.vue";
import AcceptModalButton from "@/components/modals/AcceptModalButton.vue";
import DragIcon from "@/components/icons/DragIcon.vue";
import IconPen from "@/components/icons/IconPen.vue";
import draggable from "vuedraggable";
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import VInput from "@/components/ui/VInput.vue";
import IconCross from "@/components/icons/IconCross.vue";
import SuccessSmallIcon from "@/components/icons/SuccessSmallIcon.vue";

export default {
  name: "BookingEditFloorsDropdown",

  components: {
    SuccessSmallIcon,
    IconCross,
    VInput,
    IconPen,
    DragIcon,
    AcceptModalButton,
    IconDeleteCan,
    IconPlus,
    IconSelectArrow,
    draggable,
    PerfectScrollbar,
  },

  data() {
    return {
      isFocused: false,
      isOpened: false,
      highlightIndex: -1,
      editId: null,
      editName: "",
    };
  },

  watch: {
    editId(newVal) {
      if (newVal) {
        this.editName = this.floors.find((el) => el.id === newVal).name;
      }
    },
  },

  computed: {
    floors: {
      get() {
        return [...this.$store.state.booking.floors].sort(
          (a, b) => a.order - b.order
        );
      },
      set(newFloors) {
        newFloors.forEach((floor, index) => {
          floor.order = index;
        });
        this.$store.commit({
          type: "setFloors",
          value: newFloors,
        });
      },
    },
    floor() {
      return this.$store.state.booking.floor;
    },
    classList() {
      return {
        [`dropdown-${this.size}`]: this.size,

        _focused: this.isFocused,
        _opened: this.isOpened,
        _disabled: this.isDisabled,
        _error: this.error,
        _selected: this.selectedLabel,
        _label: this.label,
        _large: this.large,
      };
    },

    selectedLabel() {
      if (this.value && this.selectedOption) {
        return this.selectedOption.label
          ? this.selectedOption.label
          : this.selectedOption;
      } else {
        return this.placeholder || "Выберите";
      }
    },
  },

  methods: {
    saveInputValue() {
      this.$store.commit({
        type: "setFloorName",
        value: { name: this.editName, id: this.editId },
      });
      this.editId = null;
      this.editName = null;
    },
    deleteFloor(index) {
      this.$store.commit({
        type: "deleteFloor",
        value: index,
      });
    },
    addFloor() {
      this.$store.commit({
        type: "addFloor",
      });
    },
    navigateOptions(direction) {
      if (!this.isOpened) {
        this.isOpened = true;
        return;
      }
      if (direction === "down") {
        this.highlightIndex++;
        if (this.highlightIndex === this.floors.length) {
          this.highlightIndex = 0;
        }
      } else if (direction === "up") {
        this.highlightIndex--;
        if (this.highlightIndex < 0) {
          this.highlightIndex = this.floors.length - 1;
        }
      }
      const option = this.floors[this.highlightIndex];
      if (option.disabled) {
        this.navigateOptions(direction);
      }
    },

    toggleMenu() {
      if (this.isDisabled) {
        return;
      }
      this.isOpened = !this.isOpened;
      if (this.isOpened) {
        this.$refs.input.focus();
      }
    },

    onEnterPress() {
      if (!this.isOpened) {
        this.toggleMenu();
      } else if (this.floors[this.highlightIndex]) {
        this.onOptionSelect(this.floors[this.highlightIndex]);
      }
    },

    onOptionSelect(order) {
      this.$store.commit({
        type: "setFloor",
        value: order,
      });
    },

    onFocus() {
      this.isFocused = true;
      this.$emit("focus");
    },

    onBlur() {
      if (this.isOpened) {
        this.isOpened = false;
      }
      this.isFocused = false;
      this.$emit("blur");
    },

    onClickOutside() {
      this.isOpened = false;
      this.isFocused = false;
      this.$emit("blur");
    },

    closeInput() {
      this.editId = null;
      this.editName = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.label {
  position: absolute;
  top: -4px;
  left: 0;
  transform: translatey(-100%);
  user-select: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #858585;
}

.dropdown {
  position: relative;
  display: inline-block;
  user-select: none;
  flex-wrap: wrap;
  background-color: #ffffff;
  border-radius: 12px;

  @include mobile {
    border-radius: 8px;
  }

  $block: &;

  &__required {
    position: absolute;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #f03738;
  }

  &._opened {
    .dropdown__arrow {
      &._reversed {
        svg {
          transform: rotate(0);
        }
      }
      svg {
        transform: rotate(180deg);
      }
    }
  }

  &._disabled {
    .dropdown__field {
      opacity: 0.5;
      pointer-events: none;

      &:hover {
        .dropdown__input {
          color: #858585;
        }
      }
    }

    .dropdown__input {
      text-align: left;
      color: #858585;
    }

    .dropdown__arrow {
      color: orange;
    }
  }

  &._label {
    .dropdown__field {
      margin-top: 18px;
    }
  }

  &.dropdown-stretch {
    display: block;

    .dropdown__field {
      display: inline-flex;
      width: auto;
    }

    .dropdown__menu {
      width: 100%;
    }
  }

  &__field {
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
    outline: none;

    padding: 20px 12px;
    width: 180px;
    min-width: 120px;
    height: 48px;
    border: 2px solid #f18e35;
    border-radius: 12px;

    background-color: #ffffff;
  }

  &__input {
    display: inline-block;
    width: 100%;
    transition: color 0.3s ease;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #f18e35;
  }

  &__arrow {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;

    color: orange;
    transition: transform 0.2s ease;
    cursor: pointer;
    overflow: hidden;

    &._reversed {
      svg {
        transform: rotate(180deg);
      }
    }
  }

  &__menu {
    position: absolute;
    width: 356px;
    top: 60px;
    z-index: 19;
    background: #f18e35;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 16px 0 #00000014;

    @include mobile {
      top: 36px;
    }

    &._reverse {
      top: auto;
      bottom: 58px;

      @include mobile {
        bottom: 36px;
      }
    }

    &.menu-enter-active,
    &.menu-leave-active {
      opacity: 1;
      transition: all 0.3s;
    }

    &.menu-enter,
    &.menu-leave-to {
      opacity: 0;
      transition: all 0.3s ease;
    }
  }

  &__scrollbox {
    width: 100%;
    max-height: 500px;
  }

  &__button {
    margin: 9px 12px;
  }

  &__option {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    background: #ffffff;
    padding: 14px 16px 14px 8px;
    transition: color 0.3s ease;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;

    .title {
      color: #222222;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
    }

    .order {
      color: #adadad;
    }

    svg {
      cursor: pointer;
      flex: 0 0 auto;
    }

    &:first-child {
      border-radius: 12px 12px 0 0;
    }

    &:last-child {
      border-radius: 0 0 12px 12px;
    }
  }

  &__native {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: -1;

    &._visible {
      pointer-events: auto;
      z-index: 2;
    }

    &.required {
      z-index: 2;
      display: block;
      pointer-events: auto;
    }
  }
}

.button {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  color: #ffffff;
  padding: 10px;
  cursor: pointer;
}

.input_text {
  border: none;
  height: 22px;
  padding: 0;

  :deep(.input_text) {
    padding: 0;
    font-size: 16px;
    line-height: 22px;
  }
}
</style>
<style src="vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css" />
